/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export enum NodeStatusCode {
    ACTIVE = 0,
    LEAVING = 1,
    PASSIVE = 2,
    UNAVAILABLE = 3,
    SUSPICIOUS = 4,
    MONITORING = 5,
    UNCONFIGURED = 6
}
